import { PrimaryButton } from '@janeapp/burrito-design-system';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const Error = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorType = searchParams.get('type');
  const errorValue = searchParams.get('value') || 'unknown';

  const handleStartNewSearch = () => {
    navigate('/');
  };

  const getErrorMessage = () => {
    switch (errorType) {
      case 'invalid-discipline':
        return {
          userMessage: `The discipline "${errorValue}" is not supported.`,
        };
      default:
        return {
          userMessage: 'An unknown error occurred.',
        };
    }
  };

  const { userMessage } = getErrorMessage();

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="max-w-md space-y-6 text-center">
        <div className="space-y-4">
          <h1 className="text-2xl font-semibold text-neutral-90">
            Oops! Something went wrong
          </h1>
          <p className="text-lg text-neutral-70">{userMessage}</p>
        </div>

        <PrimaryButton
          onClick={handleStartNewSearch}
          className="w-full"
          data-testid="start-new-search-button"
        >
          Start a new search
        </PrimaryButton>
      </div>
    </div>
  );
};
